// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestProtocolId } from './HarvestProtocol';
import { batchTypeEnum } from './BatchTypeEnum';
import { operatorId } from './Operator';
import { equipmentId } from './Equipment';
import { harvestOperationTemplateId } from './HarvestOperationTemplate';
import { z } from 'zod';
export const harvestProtocolOperationTemplateId = (z.number());
export const harvestProtocolOperationTemplate = z.object({
    id: harvestProtocolOperationTemplateId,
    harvest_protocol_id: harvestProtocolId,
    depends_on: harvestProtocolOperationTemplateId.nullable(),
    depends_on_material: batchTypeEnum.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    planned_start_amount_unit: z.string().nullable(),
    planned_start_amount_value: z.string().nullable(),
    equipment_id: equipmentId.nullable(),
    template_id: harvestOperationTemplateId,
    sort_order: z.number().nullable(),
    stage_key: z.string().nullable(),
});
export const harvestProtocolOperationTemplateInitializer = z.object({
    id: harvestProtocolOperationTemplateId.optional(),
    harvest_protocol_id: harvestProtocolId,
    depends_on: harvestProtocolOperationTemplateId.optional().nullable(),
    depends_on_material: batchTypeEnum.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    planned_start_amount_unit: z.string().optional().nullable(),
    planned_start_amount_value: z.string().optional().nullable(),
    equipment_id: equipmentId.optional().nullable(),
    template_id: harvestOperationTemplateId,
    sort_order: z.number().optional().nullable(),
    stage_key: z.string().optional().nullable(),
});
export const harvestProtocolOperationTemplateMutator = z.object({
    id: harvestProtocolOperationTemplateId.optional(),
    harvest_protocol_id: harvestProtocolId.optional(),
    depends_on: harvestProtocolOperationTemplateId.optional().nullable(),
    depends_on_material: batchTypeEnum.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    planned_start_amount_unit: z.string().optional().nullable(),
    planned_start_amount_value: z.string().optional().nullable(),
    equipment_id: equipmentId.optional().nullable(),
    template_id: harvestOperationTemplateId.optional(),
    sort_order: z.number().optional().nullable(),
    stage_key: z.string().optional().nullable(),
});
//# sourceMappingURL=HarvestProtocolOperationTemplate.js.map